module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.9ece5b48.ttf";